// extracted by mini-css-extract-plugin
module.exports = {"chip":"ProjectsOverviewPage_chip__95XRt","alertNotificationsHeader":"ProjectsOverviewPage_alertNotificationsHeader__2DKUR","helpIcon":"ProjectsOverviewPage_helpIcon__1QLa4"};